import { Component, Vue } from 'vue-property-decorator'
import { GetNewShopList, UpdateNewShopInfo, GetAppPayTypeList, UpdateAppPayTypeList, GetPayUserTypeConfig, UpdatePayUserTypeConfig, GetNewShopConfig, AddNewShopConfig, UpdateNewShopConfig, GetAllAppMch, GetAppChannelList } from '../../../api/admin/newpayment'
import { GetToken } from '../../../libs/util'
import InputSear from '@/views/components/InputSear.vue'
@Component({
    components: {
        InputSear
    }
})
export default class RechargeConf extends Vue {
    SysConstType: any = {}
    countrycode: any = []
    select = {
        pay_list: [], //对应盘口支付平台列表
        pay_type_List: [], //支付类型列表
        channel_type_list: [], //通道类型列表
        log_type_de_List: [] //操作详细分类
    }
    //银行卡支付页面
    bankPay = {
        column: [
            this.getBaseColumn('name', '支付界面', '显示该条信息对应的支付界面'),
            {
                key: 'status',
                align: 'center',
                render: (h, params) => {
                    let str = params.row.status ? '开启' : '关闭'
                    return h('span', { style: { color: params.row.status ? '#32CD32' : 'red' } }, str)
                },
                renderHeader: (h: any) => (this as any).renderHeader(h, '页面状态', '显示页面状态')
            },
            this.getBaseColumn('card_type', '银行卡名称', '显示收款银行卡的银行名称'),
            this.getBaseColumn('card_no', '银行卡号', '显示收款银行卡的银行卡号'),
            this.getBaseColumn('card_name', '持卡人姓名', '显示收款银行卡的持卡人姓名'),
            {
                title: '支付按钮展示',
                key: 'pay_num_list',
                align: 'center',
                render: (h, params) => {
                    let arr = params.row.pay_num_list
                    if (arr) {
                        return h(
                            'div',
                            arr.map((v) => h('span', { style: { margin: '2px' }, domProps: { innerHTML: v } }))
                        )
                    } else {
                        return h('div', arr)
                    }
                }
            },
            this.getBaseColumn('update_time', '更新时间', '最后一次修改信息的时间'),
            {
                title: '管理',
                key: 'general',
                align: 'center',
                minWidth: 30,
                render: (h, params) => {
                    return h('div', [
                        h(
                            'Button',
                            {
                                props: { type: 'primary' },
                                style: this.getButtonStyle(20),
                                on: {
                                    click: () => {
                                        let list: any = ['', '', '', '', '', '', '', '']
                                        if (params.row.pay_num_list) {
                                            let length = params.row.pay_num_list.length
                                            list.splice(0, length, ...params.row.pay_num_list)
                                        }
                                        this.bankPay.pay_num_list = list
                                        this.bankPay.type = 1
                                        this.bankPay.id = params.row.id
                                        this.bankPay.status = params.row.status
                                        this.bankPay.data_one = params.row.card_type
                                        this.bankPay.data_two = params.row.card_no
                                        this.bankPay.data_three = params.row.card_name
                                        this.bankPay.tabsname = '1'
                                        this.bankPay.show = true
                                    }
                                }
                            },
                            '编辑'
                        ),
                        h(
                            'Button',
                            {
                                props: { type: params.row.status ? 'warning' : 'success' },
                                style: this.getButtonStyle(20),
                                on: {
                                    click: () => {
                                        if (params.row.pay_num_list) {
                                            this.onlingPay.pay_num_list = params.row.pay_num_list
                                        }
                                        this.bankPay.type = 1
                                        this.bankPay.id = params.row.id
                                        this.bankPay.status = params.row.status ? 0 : 1
                                        this.bankPay.data_one = params.row.card_type
                                        this.bankPay.data_two = params.row.card_no
                                        this.bankPay.data_three = params.row.card_name
                                        this.Updateback()
                                    }
                                }
                            },
                            params.row.status ? '禁用' : '开启'
                        )
                    ])
                }
            }
        ],
        data: [],
        show: false,
        type: 1,
        status: 1,
        data_one: '',
        data_two: '',
        data_three: '',
        tabsname: '1',
        id: '',
        shop_id: '',
        pay_num_list: []
    }
    onlingPay = {
        titlename: '',
        app_version: 0,
        app_mch_id: 0,
        channel_id: 0, //选择的通道ID
        channel_list: [], //通道列表
        channel_type: 0,
        show: false,
        pay_key: '',
        shop_id: '',
        data: [],
        column: [
            { title: '排序', key: 'seq', align: 'center', minWidth: 40 },
            { key: 'name', align: 'center', minWidth: 65, renderHeader: (h: any) => (this as any).renderHeader(h, '支付展示页', '显示该支付页面的名称') },
            {
                key: 'status',
                align: 'center',
                minWidth: 40,
                render: this.getStatusSpan(),
                renderHeader: (h: any) => (this as any).renderHeader(h, '状态', '显示该支付页面在客户端对应商城页签下是否展示')
            },
            { key: 'user_type', align: 'center', minWidth: 75, renderHeader: (h: any) => (this as any).renderHeader(h, '界面开放用户', '显示此转入页面哪些用户可以查看并使用') },
            {
                key: 'os_type',
                align: 'center',
                minWidth: 75,
                render: (h, params) => h('span', ['不限制', '', '安卓', 'ios'][params.row.os_type || 0]),
                renderHeader: (h: any) => (this as any).renderHeader(h, '界面开放系统', '显示此转入页面哪些用户可以查看并使用')
            },
            {
                key: 'phone_model',
                align: 'center',
                minWidth: 100,
                render: (h, params) => {
                    let arr: any = []
                    let List = params.row.phone_model || []
                    this.onlingPay.phone_modelList.map((item: any) => {
                        if (List.includes(item.value)) {
                            let val: any = item.label
                            arr.push(val)
                        }
                    })
                    return h('span', arr.toString())
                },
                renderHeader: (h: any) => (this as any).renderHeader(h, '界面开放手机厂商', '显示此转入页面哪些手机厂商可以查看并使用')
            },
            {
                key: 'pay_num_list',
                align: 'center',
                minWidth: 80,
                render: (h, params) => {
                    let arr = params.row.pay_num_list
                    if (arr) {
                        return h(
                            'div',
                            arr.map((v) => {
                                // 遍历后台params.row.manager_list
                                return h('span', {
                                    style: { margin: '2px' },
                                    domProps: { innerHTML: v }
                                })
                            })
                        )
                    } else {
                        return h('div', '')
                    }
                },
                renderHeader: (h: any) => (this as any).renderHeader(h, '支付按钮配置', '显示该支付界面配置的转入按钮上的金额；每个按钮金额之间用逗号分隔')
            },
            {
                key: 'pay_type_list',
                align: 'center',
                minWidth: 85,
                render: (h, params) => {
                    let list = params.row.pay_type_list
                    if (list)
                        return h(
                            'div',
                            list.map((v: any) => h('div', { domProps: { innerHTML: v } }))
                        )
                    return h('div', '')
                },
                renderHeader: (h: any) => (this as any).renderHeader(h, '已启用配置通道', '显示该支付界面已经启用的支付通道')
            },
            { key: 'tip', align: 'center', minWidth: 90, renderHeader: (h: any) => (this as any).renderHeader(h, '界面温馨提示', '显示该界面配置的温馨提示文本') },
            {
                title: '管理',
                key: 'general',
                align: 'center',
                minWidth: 270,
                render: (h, params) => {
                    return h('div', [
                        h(
                            'Button',
                            {
                                props: { type: 'primary', size: 'small' },
                                style: { margin: '2px' },
                                on: {
                                    click: () => {
                                        this.onlingPay.name = params.row.name
                                        this.onlingPay.status = params.row.status
                                        this.onlingPay.tip = params.row.tip
                                        this.onlingPay.user_type = params.row.user_type
                                        this.onlingPay.seq = params.row.seq
                                        this.onlingPay.app_version = params.row.app_version
                                        this.onlingPay.os_type = params.row.os_type || 0
                                        this.onlingPay.phone_model = params.row.phone_model || []
                                        this.onlingPay.user_type = []
                                        this.onlingPayUser.data.map((item: any) => {
                                            params.row.user_type.map((val) => {
                                                if (item.user_type_name == val) {
                                                    let value: any = item.id
                                                    ;(this.onlingPay.user_type as any).push(value)
                                                }
                                            })
                                        })
                                        this.onlingPay.type = 1
                                        this.onlingPay.id = params.row.id
                                        if (params.row.pay_num_list) {
                                            this.onlingPay.pay_num_list = params.row.pay_num_list
                                        }
                                        this.onlingPay.setshow = true
                                    }
                                }
                            },
                            '编辑界面配置'
                        ),
                        h(
                            'Button',
                            {
                                props: { type: 'success', size: 'small' },
                                style: { margin: '2px' },
                                on: {
                                    click: () => {
                                        // let pay_num_list: any = ["", "", "", "", "", "", "", ""];
                                        let pay_num_list: any = [null, null, null, null, null, null, null, null]
                                        this.onlingPay.pay_num_list = pay_num_list
                                        if (params.row.pay_num_list) {
                                            let numList = JSON.parse(JSON.stringify(params.row.pay_num_list))
                                            if (numList.length) {
                                                numList.map((v: any, i: any) => {
                                                    ;(this.onlingPay.pay_num_list as any)[i] = v
                                                })
                                            }
                                        }
                                        this.onlingPay.name = params.row.name
                                        this.onlingPay.status = params.row.status
                                        this.onlingPay.tip = params.row.tip
                                        this.onlingPay.seq = params.row.seq
                                        this.onlingPay.user_type = params.row.user_type
                                        this.onlingPay.type = 1
                                        this.onlingPay.id = params.row.id
                                        this.onlingPay.tabsname = '1'
                                        this.onlingPay.pay_num_type = params.row.pay_num_type
                                        this.GetShopConfig(1, params.row.pay_num_channel_id)
                                        this.onlingPay.aisleShow = true
                                    }
                                }
                            },
                            '支付通道配置'
                        ),
                        h(
                            'Button',
                            {
                                props: { type: 'error', size: 'small' },
                                style: { margin: '2px' },
                                on: {
                                    click: () => {
                                        this.onlingPay.type = 2
                                        this.onlingPay.id = params.row.id
                                        this.onlingPay.name = params.row.name
                                        if (params.row.pay_num_list) {
                                            this.onlingPay.pay_num_list = params.row.pay_num_list
                                        }
                                        this.removetype()
                                    }
                                }
                            },
                            '删除'
                        )
                    ])
                }
            }
        ],
        setshow: false,
        id: '',
        status: 1,
        type: 0,
        tip: '',
        seq: 1,
        os_type: 0,
        user_type: [],
        name: '',
        aisleShow: false,
        pay_num_list: [],
        pay_num_type: 1,
        pay_num_channel_id: 0,
        tabsname: '1',
        channel_pay_list: [],
        aisleData: [],
        aisleColumn: [
            { title: '通道类型', key: 'pay_type_name', align: 'center', minWidth: 80 },
            { title: '通道名称', key: 'channel_name', align: 'center', minWidth: 80 },
            {
                title: '平台名称(ID)',
                key: 'pay_name',
                align: 'center',
                minWidth: 150,
                render: (h, params) => {
                    let arr: any = []
                    arr.push(h('span', params.row.pay_name))
                    arr.push(h('span', { style: 'color:#bbbbbb' }, ` (${params.row.pay_id})`))
                    return h('div', arr)
                }
            },
            { key: 'is_topm', align: 'center', minWidth: 80, render: (h, params) => h('span', params.row.is_topm ? '调度平台' : '运营后台'), renderHeader: (h: any) => (this as any).renderHeader(h, '配置来源', '显示通道哪方配置的通道') },
            { key: 'status', align: 'center', minWidth: 80, render: this.getStatusSpan(), renderHeader: (h: any) => (this as any).renderHeader(h, '状态', '显示该支付页面在客户端对应商城页签下是否展示') },
            {
                key: 'rand_num',
                align: 'center',
                minWidth: 150,
                render: (h, params) => {
                    let rate = '0%'
                    if (params.row.status) {
                        rate =
                            this.onlingPay.paynum != 0
                                ? Number(
                                      parseFloat(`${(params.row.rand_num / this.onlingPay.paynum) * 100}`)
                                          .toFixed(3)
                                          .slice(0, -1)
                                  ) + '%'
                                : '0%'
                    }
                    let num = 0
                    return h('div', [
                        h('InputNumber', {
                            props: { value: params.row.rand_num },
                            on: {
                                'on-change': (event) => {
                                    num = event
                                },
                                'on-blur': (event) => {
                                    if (num == 0 || num == params.row.rand_num) return
                                    let { id, status } = params.row
                                    this.updateOnlingPayStatus(id, status, num)
                                    this.UpdateNewConfig(0)
                                }
                            }
                        }),
                        h('span', { style: { width: '50px', display: 'inline-block' } }, rate)
                    ])
                },
                renderHeader: (h: any) => (this as any).renderHeader(h, '触发权重', '显示该支付页面在客户端对应商城页签下是否展示')
            },
            {
                title: '管理',
                align: 'center',
                width: 160,
                render: (h: any, params: any) => {
                    return h('div', [
                        h(
                            'Button',
                            {
                                props: { type: params.row.status ? 'warning' : 'success' },
                                style: this.getButtonStyle(),
                                on: {
                                    click: () => {
                                        let { id, rand_num, status } = params.row
                                        this.updateOnlingPayStatus(id, status ? 0 : 1, rand_num)
                                        this.UpdateNewConfig(1)
                                    }
                                }
                            },
                            params.row.status ? '禁用' : '启用'
                        ),
                        h(
                            'Button',
                            {
                                props: { type: 'error' },
                                style: this.getButtonStyle(),
                                on: {
                                    click: () => {
                                        let { id, rand_num, status } = params.row
                                        this.updateOnlingPayStatus(id, status ? 0 : 1, rand_num)
                                        this.onlingPay.pay_num_channel_id_del = params.row.channel_id
                                        this.removeConfig()
                                    }
                                }
                            },
                            '删除'
                        )
                    ])
                }
            }
        ],
        pay_num_channel_id_del: null,
        aisleList: [],
        aisleListData: [],
        addshow: false,
        pay_id: 0,
        pay_idlist: [],
        aisleStatus: 1,
        paynum: 0, // 总和，用来算权重
        rand_num: 0,
        pay_type: '',
        pay_config: '',
        phone_model: [],
        phone_modelList: [
            { value: 'Apple', label: '苹果' },
            { value: 'HUAWEI', label: '华为' },
            { value: 'OPPO', label: 'OPPO' },
            { value: 'vivo', label: 'vivo' },
            { value: 'HONOR', label: '荣耀' },
            { value: 'OnePlus', label: '一加' },
            { value: 'xiaomi', label: '小米' },
            { value: 'samsung', label: '三星' }
        ]
    }
    updateOnlingPayStatus(id, status, rand_mum) {
        this.onlingPay.channel_id = id
        this.onlingPay.aisleStatus = status
        this.onlingPay.rand_num = rand_mum
    }
    //线上支付用户类型配置
    onlingPayUser = {
        show: false,
        setShow: false,
        type: 0,
        column: [
            this.getBaseColumn('user_type_name', '用户类型名称', '显示该条用户类型配置的名称'),
            {
                key: 'pay_num_mix',
                align: 'center',
                render: (h, params) => h('span', this.calcBetween(params.row, 'pay_num_mix', 'pay_num_max')),
                renderHeader: (h: any) => (this as any).renderHeader(h, '历史转入次数', '显示该配置中转入次数条件的范围')
            },
            {
                key: 'pay_sum_mix',
                align: 'center',
                render: (h, params) => h('span', this.calcBetween(params.row, 'pay_sum_mix', 'pay_sum_max')),
                renderHeader: (h: any) => (this as any).renderHeader(h, '历史转入金额', '显示该配置中转入金额条件的范围')
            },
            {
                align: 'center',
                render: (h, params) => h('span', this.calcBetween(params.row, 'put_num_mix', 'put_num_max')),
                renderHeader: (h: any) => (this as any).renderHeader(h, '历史转出次数', '显示该配置中转出次数条件的范围')
            },
            {
                align: 'center',
                render: (h, params) => h('span', this.calcBetween(params.row, 'register_days_min', 'register_days_max')),
                renderHeader: (h: any) => (this as any).renderHeader(h, '注册天数配置', '显示该配置中注册天数条件的范围')
            },
            this.getBaseColumn('user_num', '符合条件用户数', '显示全平台用户中满足所有配置条件的用户数'),
            {
                title: '管理',
                key: 'general',
                align: 'center',
                width: 150,
                render: (h, params) => {
                    return h('div', [
                        h(
                            'Button',
                            {
                                props: { type: 'primary' },
                                style: this.getButtonStyle(20),
                                on: {
                                    click: () => {
                                        this.onlingPayUser.param = {
                                            ...params.row
                                        }
                                        if (params.row.pay_num_mix == -1) {
                                            this.onlingPayUser.param['pay_num_mix'] = 0
                                            this.onlingPayUser.paynumType = 2
                                        } else if (params.row.pay_num_max == -1) {
                                            this.onlingPayUser.param['pay_num_max'] = 0
                                            this.onlingPayUser.paynumType = 3
                                        }
                                        if (params.row.pay_sum_mix == -1) {
                                            this.onlingPayUser.param['pay_sum_mix'] = 0
                                            this.onlingPayUser.paysumType = 2
                                        } else if (params.row.pay_sum_max == -1) {
                                            this.onlingPayUser.param['pay_sum_max'] = 0
                                            this.onlingPayUser.paysumType = 3
                                        }
                                        if (params.row.put_num_mix == -1) {
                                            this.onlingPayUser.param['put_num_mix'] = 0
                                            this.onlingPayUser.putnumType = 2
                                        } else if (params.row.put_num_max == -1) {
                                            this.onlingPayUser.param['put_num_max'] = 0
                                            this.onlingPayUser.putnumType = 3
                                        }
                                        if (params.row.register_days_min == -1) {
                                            this.onlingPayUser.param['register_days_min'] = 0
                                            this.onlingPayUser.registerdaysType = 2
                                        } else if (params.row.register_days_max == -1) {
                                            this.onlingPayUser.param['register_days_max'] = 0
                                            this.onlingPayUser.registerdaysType = 3
                                        }
                                        this.setonlingPayUser(1)
                                    }
                                }
                            },
                            '编辑'
                        ),
                        h(
                            'Button',
                            {
                                props: {
                                    type: 'error'
                                },
                                style: this.getButtonStyle(20),
                                on: {
                                    click: () => {
                                        this.$Modal.confirm({
                                            title: '确认删除',
                                            content: '确认删除此条记录',
                                            onOk: () => {
                                                this.onlingPayUser.param['type'] = 2
                                                this.onlingPayUser.param['id'] = params.row.id
                                                this.updateonlingPayUser()
                                            }
                                        })
                                    }
                                }
                            },
                            '删除'
                        )
                    ])
                }
            }
        ],
        param: {
            app_id: 0,
            user_type_name: '',
            pay_num_mix: 0,
            pay_num_max: 0,
            pay_sum_mix: 0,
            pay_sum_max: 0,
            put_num_mix: 0,
            put_num_max: 0,
            register_days_max: 0,
            register_days_min: 0
        },
        data: [],
        setSelect: [
            { label: '区间', value: 1 },
            { label: '小于等于最大值', value: 2 },
            { label: '大于等于最小值', value: 3 }
        ],
        rule: {
            user_type_name: [
                {
                    required: true,
                    trigger: 'blur',
                    validator: (rule: any, value: any, callback: any) => {
                        if (!this.onlingPayUser.param.user_type_name) {
                            callback('请输入正确的用户类型名称')
                        } else {
                            callback()
                        }
                    }
                }
            ]
        },
        paynumType: 1,
        paysumType: 1,
        putnumType: 1,
        registerdaysType: 1
    }
    modlwidth = 1100
    table = {
        show: false,
        payType: 1,
        params: { app_id: 0, cur_app_id: 0, plat_id: 0 },
        data: [],
        columns: [
            { type: 'index', title: '序号', width: 50, align: 'center' },
            {
                key: 'sort',
                align: 'center',
                minWidth: 80,
                renderHeader: (h: any) => (this as any).renderHeader(h, '按钮排序', '显示该商城页签在客户端中显示的排序，排序数字越小，页签按钮越靠上展示；')
            },
            {
                key: 'name',
                align: 'center',
                minWidth: 90,
                renderHeader: (h: any) => (this as any).renderHeader(h, '页签名称名称', '显示该商城页签在客户端展示的文本名称')
            },
            {
                key: 'status',
                align: 'center',
                minWidth: 90,
                render: this.getStatusSpan(),
                renderHeader: (h: any) => (this as any).renderHeader(h, '页签状态', '显示该页签在客户端是否展示；启用（绿色）、禁用（红色）')
            },
            {
                title: '页签展示形式',
                key: 'rand_sort',
                align: 'center',
                minWidth: 80,
                render: (h, params) => h('span', { style: { color: params.row.rand_sort ? '#32CD32' : 'red' } }, params.row.rand_sort ? '固定' : '随机'),
                renderHeader: (h: any) => (this as any).renderHeader(h, '页签展示形式', '显示该页签在客户端是否；固定（绿色）、随机（红色）')
            },
            {
                key: 'pay_key',
                align: 'center',
                minWidth: 90,
                render: (h, params) => h('div', [h('span', { style: { color: params.row.tip_status == 1 ? '#32CD32' : 'red' } }, params.row.tip_status == 1 ? '启用：' : '禁用'), h('span', params.row.tip_status == 1 ? params.row.tip : '')]),
                renderHeader: (h: any) => (this as any).renderHeader(h, '页签标识', '显示对应商城转入页签上的标识是否展示')
            },
            {
                key: 'back_rate',
                align: 'center',
                minWidth: 90,
                render: (h, params) => h('div', [h('span', { style: { color: params.row.back_status == 1 ? '#32CD32' : 'red' } }, params.row.back_status == 1 ? '启用：' : '禁用'), h('span', params.row.back_status == 1 ? (params.row.back_rate || 0) + ' %' : '')]),
                renderHeader: (h: any) => (this as any).renderHeader(h, '自动转入赠送', '显示开启返利后，玩家转入的返利比例')
            },
            {
                key: 'desc',
                align: 'center',
                minWidth: 240,
                renderHeader: (h: any) => (this as any).renderHeader(h, '默认温馨提示', '显示页签界面转入温馨提示文本')
            },
            {
                key: '',
                align: 'center',
                minWidth: 250,
                fixed: 'right',
                render: (h, params) => {
                    return h('div', [
                        h(
                            'Button',
                            {
                                props: { type: 'primary' },
                                style: this.getButtonStyle(20),
                                on: {
                                    click: () => this.showModalEdit(params.row)
                                }
                            },
                            '编辑页签'
                        ),
                        h(
                            'Button',
                            {
                                props: { type: 'primary' },
                                style: this.getButtonStyle(20),
                                on: {
                                    click: () => this.showOnlinePay(params.row)
                                }
                            },
                            '配置支付界面'
                        )
                    ])
                },
                renderHeader: (h: any) => (this as any).renderHeader(h, '管理', '操作管理')
            }
        ],
        total: 0,
        pageSizes: [10, 20, 30, 40]
    }
    //页签配置界面
    modalEdit = {
        ref: 'modalEditRef',
        show: false,
        name: '',
        status: 1,
        sort: 0,
        tip_status: 1,
        rand_sort: 1,
        tip: '',
        pay_key: '',
        back_status: 1,
        back_rate: 0,
        desc: '',
        sale_num: 0,
        id: '',
        rule: {
            name: [{ required: true, trigger: 'blur', validator: (this as any).simpleVerify('请输入正确的页签名称') }],
            sort: [{ required: true, trigger: 'blur', validator: (this as any).simpleVerify('请输入正确的页签排序') }],
            tip: [
                {
                    required: true,
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        if (!value || value.length > 8) {
                            callback('请输入正确的标识文本且长度不能超过8')
                        } else {
                            callback()
                        }
                    }
                }
            ],
            back_rate: [
                {
                    required: true,
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        if (typeof value != 'number') {
                            callback('请输入正确的真实返利比例')
                        } else {
                            callback()
                        }
                    }
                }
            ],
            desc: [
                {
                    required: true,
                    trigger: 'blur',
                    validator: (rule, value, callback) => {
                        if (this.getByteLen(value) > 40) {
                            callback('温馨提示不能超过40个字符')
                        } else {
                            callback()
                        }
                    }
                }
            ]
        }
    }

    //专享闪付
    vipQuickPay = {
        data: [],
        column: [
            { key: 'name', align: 'center', minWidth: 70, renderHeader: (h: any) => (this as any).renderHeader(h, '按钮名称', '显示对应的客服按钮在客户端展示的文本') },
            {
                key: 'head_url',
                align: 'center',
                minWidth: 80,
                render: this.renderUserHead,
                renderHeader: (h: any) => (this as any).renderHeader(h, '头像', '显示对应的客服按钮在客户端展示的头像图片')
            },
            {
                title: '支持转入方式',
                key: 'pay_type',
                align: 'center',
                minWidth: 80,
                render: (h, params) => {
                    let str = ''
                    if (params.row.pay_type) {
                        for (let i = 0; i < params.row.pay_type.length; i++) {
                            if (params.row.pay_type[i] == 1001) str += '微信；'
                            if (params.row.pay_type[i] == 1000) str += '支付宝；'
                            if (params.row.pay_type[i] == 1002) str += '银行卡；'
                            if (params.row.pay_type[i] == 1003) str += '艾特@；'
                        }
                    }
                    return h('span', str)
                },
                renderHeader: (h: any) => (this as any).renderHeader(h, '支持转入方式', '对应按钮上展示的支持支付方式')
            },
            {
                key: 'code',
                align: 'center',
                minWidth: 90,
                render: (h, params) => h('div', params.row.code + params.row.phone),
                renderHeader: (h: any) => (this as any).renderHeader(h, '客服账号', '显示点击客服按钮后客服账号')
            },
            {
                key: 'xingxing',
                align: 'center',
                minWidth: 70,
                render: (h, params) => h('div', params.row.xingxing ? this.vipQuickPay.select.xxList[Number(params.row.xingxing) - 1]['name'] : ''),
                renderHeader: (h: any) => (this as any).renderHeader(h, '星级评定', '显示客服按钮上的星级评定是多少')
            },
            { key: 'sales', align: 'center', minWidth: 80, renderHeader: (h: any) => (this as any).renderHeader(h, '月销设置', '显示客服按钮上的月销数值时多少') },
            { key: 'status', align: 'center', minWidth: 80, render: this.getStatusSpan(), renderHeader: (h: any) => (this as any).renderHeader(h, '按钮状态', '显示客户按钮在客户端的展示状态') },
            {
                key: 'update_time',
                align: 'center',
                minWidth: 90,
                renderHeader: (h: any) => (this as any).renderHeader(h, '更新时间', '显示创建或最后一次修改客服按钮的时间；')
            },
            {
                title: '管理',
                key: 'general',
                align: 'center',
                minWidth: 200,
                render: (h, params) => {
                    return h('div', [
                        h(
                            'Button',
                            {
                                props: { type: 'primary' },
                                style: this.getButtonStyle(),
                                on: {
                                    click: () => {
                                        ;(this.$refs.vipQuickPay as any).resetFields()
                                        this.vipQuickPay.from.params = { ...params.row }
                                        this.vipQuickPay.from.params.type = 1
                                        this.vipQuickPay.show = true
                                    }
                                }
                            },
                            '编辑'
                        ),
                        h(
                            'Button',
                            {
                                props: {
                                    type: 'success'
                                },
                                style: this.getButtonStyle(),
                                on: {
                                    click: () => {
                                        this.vipQuickPay.from.params = { ...params.row }
                                        this.vipQuickPay.from.type = 1
                                        this.vipQuickPay.Reply.show = true
                                    }
                                }
                            },
                            '自动回复'
                        ),
                        h(
                            'Button',
                            {
                                props: { type: 'error' },
                                style: this.getButtonStyle(),
                                on: {
                                    click: () => {
                                        this.vipQuickPay.from.params = { ...params.row }
                                        this.vipQuickPay.from.params.type = 2
                                        this.$Modal.confirm({
                                            title: '确认删除',
                                            content: '<p>是否确认删除此条专享支付通道</p>',
                                            onOk: () => {
                                                this.UpdateAppQuickPay()
                                            }
                                        })
                                    }
                                }
                            },
                            '删除'
                        )
                    ])
                }
            }
        ],
        select: {
            xxList: [
                { value: '1', name: '3星' },
                { value: '2', name: '3.5星' },
                { value: '3', name: '4星' },
                { value: '4', name: '4.5星' },
                { value: '5', name: '5星' }
            ],
            countrycode: []
        },
        show: false,
        from: {
            params: this.initVipParam(),
            rules: {
                name: [{ required: true, message: '请输入按钮名称', trigger: 'blur' }],
                phone: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (!this.vipQuickPay.from.params.code) {
                                callback('请填写有效的手机区号和号码')
                            } else if (!value) {
                                callback('请填写有效的手机号码')
                            } else {
                                callback()
                            }
                        }
                    }
                ],
                sales: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            let reg = new RegExp(/^[0-9]*[1-9][0-9]*$/)
                            if (!reg.test(value)) {
                                callback('月销只允许正整数')
                            } else {
                                callback()
                            }
                        }
                    }
                ]
            }
        },
        Reply: { show: false, text1: '', text2: '' }
    }

    //修改支付通道通道配置
    FormPay = {
        show: false,
        pay_config: {
            with_proxy: 0,
            url: '',
            mch_id: '',
            mch_key: '',
            mch_account: '',
            mast_ip: [],
            pay_type: '',
            mch_rsa_private: '',
            mch_rsa_public: '',
            mch_md5_key: ''
        },
        mast_ip: '',
        pay_name: '',
        name: ''
        // name:'',
    }

    //vip支付页面
    vipPay = {
        show: false,
        data: [],
        column: [
            {
                key: 'name',
                align: 'center',
                renderHeader: (h: any) => (this as any).renderHeader(h, '转入名称', '对应按钮上的名称')
            },
            {
                key: 'head_url',
                align: 'center',
                render: this.renderUserHead,
                renderHeader: (h: any) => (this as any).renderHeader(h, '转入头像', '对应按钮上头像展示')
            },
            {
                key: 'pay_type',
                align: 'center',
                // width:'150',
                render: (h, params) => {
                    let str = ''
                    let arr = [, '支付宝；', '微信；', '银行卡；', '艾特@；']
                    if (params.row.pay_type) {
                        str = params.row.pay_type.reduce((res: any, cur: any) => {
                            if (arr[cur]) res += arr[cur]
                            return res
                        }, '')
                    }
                    return h('span', str)
                },
                renderHeader: (h: any) => (this as any).renderHeader(h, '支持转入方式', '对应按钮上展示的支持支付方式')
            },
            {
                key: 'ext_type',
                align: 'center',
                // width:'150',
                render: (h, params) => {
                    let str = ''
                    let arr = [, '花呗；', '信用卡;', 'qq钱包']
                    if (params.row.ext_type) {
                        str = params.row.ext_type.reduce((res: any, cur: any) => {
                            if (arr[cur]) res += arr[cur]
                            return res
                        }, '')
                    }
                    return h('span', str)
                },
                renderHeader: (h: any) => (this as any).renderHeader(h, '支持额外转入方式', '对应按钮上展示的额外支付方式')
            },
            {
                key: 'open_type',
                align: 'center',
                render: (h, params) => h('span', params.row.open_type ? '打开弹窗' : '跳转网页'),
                renderHeader: (h: any) => (this as any).renderHeader(h, '展开方式', '显示点击转入按钮跳转到哪里')
            },
            {
                key: 'url',
                align: 'center',
                render: (h, params) => h('span', params.row.url || '/'),
                renderHeader: (h: any) => (this as any).renderHeader(h, '外部链接网页地址', '跳转到外部链接网页地址')
            },

            {
                key: 'ali',
                align: 'center',
                render: (h, params) => {
                    let arr = ['微信', 'QQ', '公众号', '在线客服', '支付宝']
                    let main = params.row
                    return h(
                        'div',
                        arr.map((item: any, index: any) => {
                            let typeIndex = index + 1
                            let from = main[`ptype${typeIndex}`]
                            let result = from ? arr[from - 1] + ':' + main[`data${typeIndex}`] : ''
                            return h('p', result)
                        })
                    )
                },
                renderHeader: (h: any) => (this as any).renderHeader(h, '弹窗信息', '弹窗上展示信息')
            },
            {
                key: 'status',
                align: 'center',
                render: this.getStatusSpan(),
                renderHeader: (h: any) => (this as any).renderHeader(h, '状态', '该公司入账按钮是否在公司入账界面展示')
            },
            {
                key: 'update_time',
                align: 'center',
                renderHeader: (h: any) => (this as any).renderHeader(h, '更新时间', '新增或最后一次修改信息的时间；')
            },
            {
                title: '管理',
                key: 'general',
                align: 'center',
                minWidth: 60,
                render: (h, params) => {
                    return h('div', [
                        h(
                            'Button',
                            {
                                props: {
                                    type: 'primary'
                                },
                                style: this.getButtonStyle(20),
                                on: {
                                    click: () => {
                                        this.vipPay.type = 1
                                        this.vipPay.id = params.row.id
                                        this.vipPay.name = params.row.name
                                        this.vipPay.status = params.row.status
                                        this.vipPay.open_type = params.row.open_type
                                        this.vipPay.pay_type = params.row.pay_type
                                        this.vipPay.ext_type = params.row.ext_type
                                        this.vipPay.head_url = params.row.head_url
                                        this.vipPay.url = params.row.url
                                        this.vipPay.ptype_one = params.row.ptype1
                                        this.vipPay.data_one = params.row.data1
                                        this.vipPay.ptype_two = params.row.ptype2
                                        this.vipPay.data_two = params.row.data2
                                        this.vipPay.ptype_three = params.row.ptype3
                                        this.vipPay.data_three = params.row.data3
                                        this.vipPay.ptype_four = params.row.ptype4
                                        this.vipPay.data_four = params.row.data4
                                        this.vipPay.show = true
                                    }
                                }
                            },
                            '修改'
                        ),
                        h(
                            'Button',
                            {
                                props: { type: 'error' },
                                style: this.getButtonStyle(20),
                                on: {
                                    click: () => {
                                        this.vipPay.type = 2
                                        this.vipPay.id = params.row.id
                                        this.removeVipConfig()
                                    }
                                }
                            },
                            '删除'
                        )
                    ])
                }
            }
        ],
        name: '',
        status: 1,
        head_url: 1,
        open_type: 1,
        pay_type: [],
        ext_type: [],
        type: 1,
        url: '',
        typelist: [
            { name: '微信', value: 1 },
            { name: 'QQ', value: 2 },
            { name: '公众号', value: 3 },
            { name: '在线客服', value: 4 },
            { name: '支付宝', value: 5 }
        ],
        id: '',
        ptype_one: 0,
        shop_id: '',
        data_one: '',
        ptype_two: 0,
        data_two: '',
        ptype_three: 0,
        data_three: '',
        ptype_four: 0,
        data_four: ''
    }
    //支付通道单选框选择
    changeChannelRadio(type) {
        if (type == 2) {
            this.changeChannelPay(this.onlingPay.pay_num_channel_id)
        }
    }
    //选择支付通道
    changeChannelPay(type) {
        let obj = this.onlingPay.channel_pay_list.filter((v: any) => v.channel_id == type)
        let arr: any = []
        if (obj.length == 0) {
            arr = [0, 0, 0, 0, 0, 0, 0, 0]
            this.onlingPay.pay_num_list = arr
        } else {
            arr = obj[0]['pay_num_list'] == [] || obj[0]['pay_num_list'] == null ? [0, 0, 0, 0, 0, 0, 0, 0] : obj[0]['pay_num_list']
            this.onlingPay.pay_num_list = arr
        }
    }
    //支付通道配置和支付按钮配置
    tabname(name) {
        this.onlingPay.tabsname = name
        if (this.onlingPay.pay_num_type == 2 && name == 2) {
            this.changeChannelPay(this.onlingPay.pay_num_channel_id)
        }
    }
    //判断字符串长度
    getByteLen(val) {
        let len = 0
        for (let i = 0; i < val.length; i++) {
            let a = val.charAt(i)
            if (a.match(/[^\x00-\xff]/gi) != null) {
                len += 2
            } else {
                len += 1
            }
        }
        return len
    }

    //更新银行卡信息
    Updateback() {
        if (this.bankPay.tabsname == '2') {
            if (!this.bankPay.data_one) return this.$Message.error('请输入银行名称')
            if (!this.bankPay.data_two) return this.$Message.error('请输入银行卡号')
            if (!this.bankPay.data_three) return this.$Message.error('请输入持卡人姓名')
        }
        let numlist: any = []
        if (this.bankPay.pay_num_list.length == 0) {
            numlist = []
        } else {
            this.bankPay.pay_num_list.map((v) => {
                numlist.push(v || 0)
            })
        }
        let param = {
            ...this.getCurParams(),
            type: this.bankPay.type,
            id: this.bankPay.id,
            shop_id: this.bankPay.shop_id,
            pay_num_list: numlist,
            pay_key: this.onlingPay.pay_key,
            status: this.bankPay.status,
            data_one: this.bankPay.data_one,
            data_two: this.bankPay.data_two,
            data_three: this.bankPay.data_three
        }
        UpdateAppPayTypeList(param).then((res) => {
            this.$Message.success('修改成功')
            this.GetAppPayTypeList({})
            this.bankPay.show = false
        })
    }
    setonlingPayUser(type, id?) {
        if (type == 0) {
            this.onlingPayUser.param.user_type_name = ''
            this.onlingPayUser.param.pay_num_mix = 0
            this.onlingPayUser.param.pay_num_max = 0
            this.onlingPayUser.param.pay_sum_mix = 0
            this.onlingPayUser.param.pay_sum_max = 0
            this.onlingPayUser.param.put_num_mix = 0
            this.onlingPayUser.param.put_num_max = 0
            this.onlingPayUser.param.register_days_min = 0
            this.onlingPayUser.param.register_days_max = 0
            this.onlingPayUser.paynumType = 1
            this.onlingPayUser.paysumType = 1
            this.onlingPayUser.putnumType = 1
            this.onlingPayUser.registerdaysType = 1
        }
        this.onlingPayUser.param['type'] = type
        if (id) this.onlingPayUser.param['id'] = id
        this.onlingPayUser.setShow = true
    }
    //删除支付通道配置
    removeConfig() {
        this.$Modal.confirm({
            title: '删除信息',
            content: '是否确认删除该条支付通道配置信息？',
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                this.UpdateNewConfig(2)
            },
            onCancel: () => {
                this.$Message.info('已取消删除')
            }
        })
    }
    //提交页签配置界面表单
    handleSubmit() {
        ;(this.$refs[this.modalEdit.ref] as any).validate((valid: boolean) => {
            if (valid) this.UpdateShop()
        })
    }
    //更新商城页签
    UpdateShop() {
        let { id, sort, status, name, pay_key, tip_status, tip, back_status, back_rate, desc, rand_sort } = this.modalEdit
        let param = { ...this.getCurParams(), id, sort, status, name, pay_key, tip_status, tip, back_status, back_rate, desc, rand_sort }
        UpdateNewShopInfo(param).then((res) => {
            this.$Message.success('修改成功')
            this.modalEdit.show = false
            this.GetNewShopList()
        })
    }
    //获取商城页签列表
    GetNewShopList() {
        this.table.params.plat_id = this.getPlatIdByAppId(this.table.params.app_id)
        this.table.params.cur_app_id = this.table.params.app_id
        GetNewShopList(this.table.params).then((res) => {
            this.table.data = res._param.data || []
        })
    }
    closeSetUser() {
        // (this.$refs[this.modalEdit.ref] as any).resetFields();
        this.modalEdit.show = false
    }
    showModalEdit(params: any) {
        this.modalEdit.show = true
        Object.assign(this.modalEdit, { ...params })
    }
    getPlatIdByAppId(id) {
        let item: any = (this as any).app_list.find((el: any) => el.appid == id)
        return item ? item.platform : 0
    }
    showOnlinePay(params: any) {
        this.onlingPay.titlename = params.name
        this.onlingPay.pay_key = params.pay_key
        this.onlingPay.shop_id = params.id
        this.table.payType = params.type
        this.vipPay.shop_id = params.id
        this.GetAppPayTypeList({ shop_id: params.shop_id })
        this.onlingPayUserlist()
        this.table.show = true
    }
    //删除商城配置信息
    removetype() {
        this.$Modal.confirm({
            title: '删除信息',
            content: '是否确认删除该条商城配置信息？',
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                this.UpdatePayTypeList()
            },
            onCancel: () => {
                this.$Message.info('已取消删除')
            }
        })
    }
    //更新商城配置
    UpdatePayTypeList() {
        if (!this.onlingPay.name || this.getByteLen(this.onlingPay.name) > 10) return this.$Message.error('请输入正确的页面名称')
        if (this.onlingPay.tip && this.getByteLen(this.onlingPay.tip) > 40) return this.$Message.error('请输入正确的提示且不能超过40个字符')
        let num = this.onlingPay.channel_pay_list.filter((v: any) => v.channel_id == this.onlingPay.pay_num_channel_id)
        if (this.onlingPay.pay_num_type == 2 && num.length == 0) {
            return this.$Message.error('请选择需要读取的通道配置')
        }
        let numlist: any = []
        if (this.onlingPay.pay_num_list.length > 0) {
            this.onlingPay.pay_num_list.map((v) => {
                numlist.push(v || 0)
            })
        }

        let param = {
            ...this.getCurParams(),
            pay_num_list: numlist,
            id: this.onlingPay.type != 0 ? this.onlingPay.id : '',
            name: this.onlingPay.name, // 名字
            shop_id: this.onlingPay.shop_id,
            os_type: this.onlingPay.os_type,
            pay_key: this.onlingPay.pay_key, // 按钮
            phone_model: this.onlingPay.phone_model, // 手机限制
            seq: this.onlingPay.seq,
            status: this.onlingPay.status,
            tip: this.onlingPay.tip,
            type: this.onlingPay.type, // 类型
            user_type: this.onlingPay.user_type,
            app_version: this.onlingPay.app_version || 0,
            pay_num_type: this.onlingPay.pay_num_type,
            pay_num_channel_id: this.onlingPay.pay_num_channel_id
        }
        UpdateAppPayTypeList(param).then((res) => {
            this.updateNotify(this.onlingPay.type)
            this.onlingPay.setshow = false
        })
    }
    //提交支付用户类型配置
    SubmitonlingPayUser() {
        ;(this.$refs.onlingPayUser as any).validate((valid: boolean) => {
            if (valid) this.updateonlingPayUser()
        })
    }
    getCurParams() {
        let app_id = this.table.params.cur_app_id
        return { plat_id: this.getPlatIdByAppId(app_id), app_id }
    }
    //获取配置支付界面
    GetAppPayTypeList(params: any) {
        let param: any = { ...this.getCurParams(), ...params }
        param.pay_key = this.onlingPay.pay_key
        param.shop_id = this.onlingPay.shop_id
        GetAppPayTypeList(param).then((res) => {
            this.onlingPay.data = res._param.data || []
        })
        GetAllAppMch(param).then((res) => {
            this.onlingPay.pay_idlist = res._param || []
        })
    }
    //获取支付通道配置
    GetShopConfig(mod, channel_id?) {
        let params = { ...this.getCurParams(), mod, pay_key: this.onlingPay.pay_key, shop_type_id: this.onlingPay.id }
        GetNewShopConfig(params).then((res) => {
            this.onlingPay.aisleData = res._param.data || []
            this.onlingPay.channel_pay_list = []
            let arr: any = []
            this.onlingPay.paynum = 0
            this.onlingPay.aisleData.map((v: any) => {
                if (v.status) {
                    this.onlingPay.paynum += v.rand_num
                }
                //支付通道按钮配置选择列表
                if (v.is_topm == 1) {
                    if (v.pay_num_list == null) {
                        v.pay_num_list = [0, 0, 0, 0, 0, 0, 0, 0]
                    } else {
                        v.pay_num_list = v.pay_num_list.length == 0 ? [0, 0, 0, 0, 0, 0, 0, 0] : v.pay_num_list
                    }
                    let obj: any = {}
                    obj['channel_id'] = v.channel_id
                    obj['channel_name'] = v.channel_name
                    obj['pay_num_list'] = v.pay_num_list
                    arr.push(obj)
                }
            })
            ;(this.onlingPay.pay_num_channel_id = channel_id || 0), (this.onlingPay.channel_pay_list = arr)
            // this.onlingPay.paynum = this.onlingPay.aisleData.reduce((res: any, cur: any) => {
            //     if (cur.status) res += cur.rand_num
            //     return res;
            // }, 0);
        })
    }

    updateonlingPayUser() {
        let param: any = { ...this.onlingPayUser.param }
        Object.assign(param, this.getCurParams())
        let mix1 = this.onlingPayUser.param.pay_num_mix
        let mix2 = this.onlingPayUser.param.pay_sum_mix
        let mix3 = this.onlingPayUser.param.put_num_mix
        let mix4 = this.onlingPayUser.param.register_days_min
        let max1 = this.onlingPayUser.param.pay_num_max
        let max2 = this.onlingPayUser.param.pay_sum_max
        let max3 = this.onlingPayUser.param.put_num_max
        let max4 = this.onlingPayUser.param.register_days_max
        if (this.isInt(mix1) || this.isInt(mix2) || this.isInt(mix3) || this.isInt(mix4)) return this.$Message.error('只能输入整数！')
        if (this.isInt(max1) || this.isInt(max2) || this.isInt(max3) || this.isInt(max4)) return this.$Message.error('只能输入整数！')
        if (this.minIsOutMax('pay', 'num', 'mix')) return
        if (this.minIsOutMax('pay', 'sum', 'mix')) return
        if (this.minIsOutMax('put', 'num', 'mix')) return
        if (this.minIsOutMax('register', 'days', 'min')) return
        this.updateParamToReq('pay', 'num', 'mix', param)
        this.updateParamToReq('pay', 'sum', 'mix', param)
        this.updateParamToReq('put', 'num', 'mix', param)
        this.updateParamToReq('register', 'days', 'min', param)
        UpdatePayUserTypeConfig(param).then((res) => {
            if (param.type == 2) {
                this.$Message.success('删除成功')
            } else {
                this.closeonlingPayUser()
                this.$Message.success('配置成功')
            }
            setTimeout(() => {
                this.onlingPayUserlist()
            }, 500)
        })
    }
    isInt(val: any) {
        return val === +val && val !== (val | 0)
    }
    minIsOutMax(val1: String, val2: String, val3: String) {
        let isError = this.onlingPayUser[`${val1}${val2}Type`] == 1 && this.onlingPayUser.param[`${val1}_${val2}_${val3}`] > this.onlingPayUser.param[`${val1}_${val2}_max`]
        if (isError) this.$Message.error('最小值不能大于最大值')
        return isError
    }
    updateParamToReq(val1: String, val2: String, val3: String, param: any) {
        if (this.onlingPayUser[`${val1}${val2}Type`] == 3) {
            param[`${val1}_${val2}_max`] = -1
        } else if (this.onlingPayUser[`${val1}${val2}Type`] == 2) {
            param[`${val1}_${val2}_${val3}`] = -1
        }
    }
    //请求支付用户类型配置
    onlingPayUserlist() {
        let param = this.getCurParams()
        GetPayUserTypeConfig(param).then((res) => {
            this.onlingPayUser.data = res._param.data || []
        })
    }
    //清空支付用户类型配置
    closeonlingPayUser() {
        ;(this.$refs.onlingPayUser as any).resetFields()
        this.onlingPayUser.setShow = false
    }
    //VIP添加
    addvipPay() {
        this.vipPay.type = 0
        this.vipPay.name = ''
        this.vipPay.status = 1
        this.vipPay.pay_type = []
        this.vipPay.ext_type = []
        this.vipPay.head_url = 1
        this.vipPay.url = ''
        this.vipPay.open_type = 1
        this.vipPay.ptype_one = 0
        this.vipPay.data_one = ''
        this.vipPay.ptype_two = 0
        this.vipPay.data_two = ''
        this.vipPay.ptype_three = 0
        this.vipPay.data_three = ''
        this.vipPay.ptype_four = 0
        this.vipPay.data_four = ''
        this.vipPay.show = true
    }

    //删除VIP配置
    removeVipConfig() {
        //                type: "warning"
        this.$Modal.confirm({
            title: '删除信息',
            content: '是否确认删除该条公司入账界面配置信息？',
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                this.updateVip()
            },
            onCancel: () => {
                this.$Message.info('已取消删除')
            }
        })
    }
    //VIP支付更新添加
    updateVip() {
        if (this.vipPay.type != 2) {
            if (!this.vipPay.name) return this.$Message.error('请输入按钮配置名称')
            if (!this.vipPay.open_type && !this.vipPay.url) return this.$Message.error('请输入外部链接')
        }
        let param = { ...this.getCurParams(), ...this.vipPay }
        let id: any = this.vipPay.type != 0 ? this.vipPay.id : ''
        param.id = id
        UpdateAppPayTypeList(param).then((res) => {
            this.updateNotify(param.type)
            this.GetAppPayTypeList({ shop_id: this.vipPay.shop_id })
            this.vipPay.show = false
        })
    }
    //判断支付通道是否需选择
    selectBol(bol) {
        if (bol && !this.onlingPay.pay_id) {
            this.onlingPay.aisleListData = []
            return this.$Message.error('请先选择支付平台')
        } else {
            // this.onlingPay.aisleListData.map((v: any) => {
            //     if (this.onlingPay.aisleName == v.name) {
            //         this.onlingPay.pay_type = v.pay_type;
            //         this.onlingPay.pay_config = v.pay_config;
            //     }
            // });
            //
        }
    }
    //新增支付通道配置
    addConfig() {
        this.onlingPay.pay_id = 0
        this.onlingPay.pay_type = ''
        this.onlingPay.aisleStatus = 1
        this.onlingPay.rand_num = 0
        this.onlingPay.channel_type = 0
        // this.GetShopConfig(0);
        this.onlingPay.addshow = true
    }
    //添加商城支付配置
    addpay() {
        this.onlingPay.id = ''
        this.onlingPay.name = ''
        this.onlingPay.status = 1
        this.onlingPay.tip = ''
        this.onlingPay.seq = 1
        this.onlingPay.os_type = 0
        this.onlingPay.type = 0
        this.onlingPay.phone_model = []
        this.onlingPay.pay_num_list = []
        let arr: any = this.onlingPayUser.data.map((item: any) => {
            return item.id
        })
        this.onlingPay.user_type = arr
        this.onlingPay.setshow = true
        this.onlingPayUserlist()
    }

    //支付通道配置和支付按钮配置
    backtabname(name) {
        this.bankPay.tabsname = name
    }
    //更新支付通道配置
    UpdateNewConfig(type) {
        // if (type != 2) {
        //   this.FormPay.pay_config["mast_ip"] = this.FormPay["mast_ip"].split(",");
        // }
        let param = {
            ...this.getCurParams(),
            type: type,
            id: this.onlingPay.channel_id,
            status: this.onlingPay.aisleStatus,
            rand_num: this.onlingPay.rand_num
        }
        UpdateNewShopConfig(param).then((res) => {
            this.GetShopConfig(1)
            if (type == 2) {
                if (this.onlingPay.pay_num_channel_id == this.onlingPay.pay_num_channel_id_del) {
                    this.onlingPay.pay_num_channel_id = 0
                    this.onlingPay.pay_num_type = 1
                    this.UpdatePayTypeList()
                }
                return this.$Message.success('删除成功')
            } else {
                return this.$Message.success('修改成功')
            }
        })
    }
    //改变支付通道
    Spaytype(value) {
        this.onlingPay.pay_type = ''
        this.onlingPay.channel_id = 0
        this.onlingPay.app_mch_id = 0
        this.onlingPay.channel_list = []
        if (value) {
            let item: any = this.onlingPay.pay_idlist.filter((el: any) => el.pay_platform_id == value)[0]
            this.onlingPay.app_mch_id = item.id
            let { app_mch_id, pay_key } = this.onlingPay
            let param = { app_mch_id, pay_key }
            GetAppChannelList(param).then((res) => {
                this.onlingPay.channel_list = res._param || []
            })
        }
    }
    UpdateAppQuickPay() {
        let param: any = { ...this.getCurParams(), ...this.vipQuickPay.from.params }
        param.pay_key = this.onlingPay.pay_key
        param.url = '11'
        param.code = String(param.code).indexOf('+') > -1 ? Number(param.code.replace('+', '')) : param['code']
        param.app_version = param.app_version || 0
        UpdateAppPayTypeList(param).then((res) => {
            this.updateNotify(this.vipQuickPay.from.params['type'])
            this.vipQuickPay.show = false
            this.vipQuickPay.Reply.show = false
        })
    }
    //新增支付通道配置
    AddNewConfig() {
        if (!this.onlingPay.pay_id) return this.$Message.error('请选择支付通道')
        if (!this.onlingPay.channel_id) return this.$Message.error('请选择通道类型')
        let { pay_key, pay_id, channel_id, app_mch_id, id } = this.onlingPay
        let param = { ...this.getCurParams(), pay_key, status: this.onlingPay.aisleStatus, rand_num: Number(this.onlingPay.rand_num) || 0, pay_id, channel_id, app_mch_id, shop_type_id: id }
        AddNewShopConfig(param).then((res) => {
            this.GetShopConfig(1)
            this.$Message.success('添加成功')
            this.GetAppPayTypeList({})
            this.onlingPay.addshow = false
        })
    }

    calcBetween(item, minType, maxType) {
        if (item[minType] == -1) return '≤' + item[maxType]
        if (item[maxType] == -1) return '≥' + item[minType]
        this.onlingPayUser.putnumType = 1
        return `${item[minType]}~${item[maxType]}`
    }

    //支付用户类型配置MOdal
    onlingPayUsershow() {
        this.onlingPayUser.show = true
        this.onlingPayUserlist()
    }
    addvipQuickPay() {
        ;(this.$refs.vipQuickPay as any).resetFields()
        this.vipQuickPay.from.params = this.initVipParam()
        this.vipQuickPay.show = true
    }
    updatevipQuickPay() {
        ;(this.$refs.vipQuickPay as any).validate((valid: boolean) => {
            if (valid) this.UpdateAppQuickPay()
        })
    }
    initVipParam() {
        return { id: 0, head_url: 1, name: '', pay_type: [], status: 1, ext_type: [], xingxing: '', sales: 0, code: null, phone: '', type: 0, text1: '', text2: '' }
    }
    getSysConst() {
        this.SysConstType = GetToken().SysConstType
        //支付类型列表
        let type_List_arr: any = []
        for (let i in this.SysConstType.pay_type) {
            type_List_arr.push({
                value: i,
                name: this.SysConstType.pay_type[i]
            })
        }
        this.select.pay_type_List = type_List_arr

        //通道类型列表
        let channel_type_list: any = []
        for (let i in this.SysConstType.channel_type) {
            channel_type_list.push({
                value: i,
                name: this.SysConstType.channel_type[i]
            })
        }
        this.select.channel_type_list = channel_type_list
    }
    getButtonStyle(padding = 10) {
        return { margin: '2px', padding: `5px ${padding}px` }
    }
    getStatusSpan() {
        return (h: any, params: any) => h('span', { style: { color: params.row.status ? '#32CD32' : 'red' } }, params.row.status ? '启用' : '禁用')
    }
    updateNotify(index: any) {
        let arr = ['添加成功', '修改成功', '删除成功']
        this.$Message.success(arr[index])
        this.GetAppPayTypeList({ shop_id: this.onlingPay.shop_id })
    }
    renderUserHead(h: any, params: any) {
        return h('div', { attrs: { style: 'width: 40px;height: 40px;margin: 0 auto;' } }, [h('img', { attrs: { src: 'img/icons/vip' + params.row.head_url + '.png', style: 'width:40px;height:40px;border-radius:2px;' }, style: {} })])
    }
    getBaseColumn(key = '', title = '', tip = '') {
        return { key, align: 'center', renderHeader: (h: any) => (this as any).renderHeader(h, title, tip) }
    }
    initFunc() {
        let item: any = (this as any).app_list[0]
        this.table.params.app_id = item.appid
        this.GetNewShopList()
    }
    created() {
        this.initFunc()
        this.getSysConst()
    }
}
